import React from 'react';
import { Provider } from 'react-redux';
import styled, { ThemeProvider } from 'styled-components';
import IntlProvider from 'i18n';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { lighten } from 'polished';

function MapMarker({ store, theme }) {
  return (
    <Provider store={store}>
      <IntlProvider namespace={'mapbox'} forMapboxMap>
        <ThemeProvider theme={theme}>
          <Root>
            <PinIcon icon='map-marker-alt' />
          </Root>
        </ThemeProvider>
      </IntlProvider>
    </Provider>
  );
}

const Root = styled.span`
  height: 21px;
  padding: 0 6px;
  color: ${({ theme }) => theme.colors.text.white};
  font-size: 2rem;
  font-weight: bold;
  text-align: center;
  cursor: pointer;
`;

const PinIcon = styled(FontAwesomeIcon)`
  filter: drop-shadow(1px 2px 2px rgba(0, 0, 0, 0.3));
  stroke: ${({ theme }) => theme.colors.secondary.light};
  stroke-width: 28px;
  transition: transform 0.6s ease;
  &:hover {
    stroke: ${({ theme }) => lighten('0.20', theme.colors.secondary.light)};
    stroke-width: 33px;
    transform: translateY(-3px);
  }
`;

export default MapMarker;
